require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-content-writing-company-tagline.json") })
        }
      }, "path---services-content-writing-company-tagline");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-content-writing-company-tagline!./.cache/json/services-content-writing-company-tagline.json
// module id = 733
// module chunks = 231608221292675